var _path, _rect, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateAd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 92,
    viewBox: "0 0 110 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.1631 65.8116C69.6186 73.8764 56.3285 88.8437 42.0487 88.8871C17.1213 83.991 26.7227 60.9007 3.9141 47.3222C-9.3814 28.2901 18.5326 17.8621 38.1116 4.18458C57.6906 -9.49296 45.3914 15.0908 85.7899 11C126.188 6.9092 108.524 58.16 81.1631 65.8116Z",
    fill: "#F5F5F5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 77.1044,
    y: 65.3545,
    width: 51.7684,
    height: 51.7684,
    rx: 14,
    transform: "rotate(-180 77.1044 65.3545)",
    fill: "#0073E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40.0226,
    height: 40.0226,
    rx: 8,
    transform: "matrix(-1 0 0 1 71.4491 19.6768)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9689 37.5977C67.9689 35.3885 66.178 33.5977 63.9689 33.5977H57.1779C54.9688 33.5977 53.1779 35.3885 53.1779 37.5977V52.2192C53.1779 54.4283 54.9688 56.2192 57.1779 56.2192H63.9689C66.178 56.2192 67.9689 54.4283 67.9689 52.2192V37.5977Z",
    fill: "#41BCFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5 37.5977C84.5 35.3885 82.7091 33.5977 80.5 33.5977H73.709C71.4998 33.5977 69.709 35.3885 69.709 37.5977V52.2192C69.709 54.4283 71.4999 56.2192 73.709 56.2192H80.5C82.7091 56.2192 84.5 54.4283 84.5 52.2192V37.5977Z",
    fill: "#41BCFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4378 37.5977C51.4378 35.3885 49.6469 33.5977 47.4378 33.5977H39.7767C37.5676 33.5977 35.7767 35.3885 35.7767 37.5977V52.2192C35.7767 54.4283 37.5676 56.2192 39.7767 56.2192H47.4378C49.6469 56.2192 51.4378 54.4283 51.4378 52.2192V37.5977Z",
    fill: "#41BCFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0366 37.5977C34.0366 35.3885 32.2458 33.5977 30.0366 33.5977H23.2456C21.0365 33.5977 19.2456 35.3885 19.2456 37.5977V52.2192C19.2456 54.4283 21.0365 56.2192 23.2456 56.2192H30.0366C32.2458 56.2192 34.0366 54.4283 34.0366 52.2192V37.5977Z",
    fill: "#41BCFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4491 27.6768C71.4491 23.2585 67.8674 19.6768 63.4491 19.6768H39.4264C35.0082 19.6768 31.4264 23.2585 31.4264 27.6768V30.1174H71.4491V27.6768Z",
    fill: "#E8E8E8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2683 24.8973C59.2683 23.4557 58.0997 22.2871 56.6581 22.2871H46.2174C44.7759 22.2871 43.6073 23.4557 43.6073 24.8973C43.6073 26.3388 44.7759 27.5075 46.2174 27.5075H56.6581C58.0997 27.5075 59.2683 26.3388 59.2683 24.8973Z",
    fill: "#BCBCBC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3008 73.1062L74.6784 58.5946C74.4152 57.9154 74.4327 57.1595 74.7269 56.4931C75.021 55.8268 75.5679 55.3046 76.2471 55.0415C76.9262 54.7784 77.6822 54.7958 78.3485 55.09C79.0148 55.3842 79.537 55.931 79.8001 56.6102L84.7611 69.4146M84.4304 68.5609L83.1074 65.1464C82.8443 64.4672 82.8617 63.7113 83.1559 63.045C83.4501 62.3787 83.9969 61.8565 84.6761 61.5934C85.3553 61.3302 86.1112 61.3477 86.7775 61.6418C87.4439 61.936 87.966 62.4829 88.2292 63.1621L89.8828 67.4302M88.8906 64.8693C88.6275 64.1901 88.6449 63.4342 88.9391 62.7679C89.2333 62.1016 89.7801 61.5794 90.4593 61.3162C91.1385 61.0531 91.8944 61.0705 92.5607 61.3647C93.2271 61.6589 93.7493 62.2057 94.0124 62.8849L95.0046 65.4458",
    stroke: "#BCBCBC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M94.674 64.5922C94.4108 63.913 94.4283 63.1571 94.7224 62.4908C95.0166 61.8245 95.5635 61.3023 96.2427 61.0391C96.9218 60.776 97.6777 60.7934 98.3441 61.0876C99.0104 61.3818 99.5326 61.9286 99.7957 62.6078L102.772 70.2905C103.825 73.0072 103.755 76.0308 102.578 78.6961C101.402 81.3614 99.2143 83.4501 96.4976 84.5027L93.0831 85.8256L93.4382 85.6881C91.7418 86.3456 89.9088 86.5716 88.1035 86.3457C86.2983 86.1198 84.5775 85.449 83.0955 84.3937L82.5624 84.0112C81.7129 83.3998 78.5808 80.865 73.1636 76.4056C72.6113 75.9511 72.2582 75.299 72.1793 74.5881C72.1005 73.8772 72.302 73.1636 72.7412 72.599C73.2088 71.9974 73.8641 71.5692 74.6029 71.3826C75.3417 71.196 76.1216 71.2616 76.8189 71.5689L80.3009 73.1062M68.5645 58.0181L66.1958 56.9723M69.5031 65.5086L67.7959 66.17M83.9298 52.065L84.9756 49.6963M87.6214 56.5253L89.3287 55.8638",
    stroke: "#BCBCBC",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateAd);
export default __webpack_public_path__ + "static/media/create-ad.3ab1b4229d089ce22c48efd8b98ffe41.svg";
export { ForwardRef as ReactComponent };